"use strict";

var _regeneratorRuntime = require("/codebuild/output/src400645628/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash.debounce"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

var _classnames = _interopRequireDefault(require("classnames"));

var _clientAwsS = require("@devsta/client-aws-s3");

var _Tags = _interopRequireDefault(require("../../../common/components/Tags"));

var _PostListItem = _interopRequireDefault(require("./PostListItem"));

var _AddPostsModal = _interopRequireDefault(require("../../../common/components/AddPostsModal"));

var _UpdateCampaignModal = _interopRequireDefault(require("../../../common/components/UpdateCampaignModal"));

var _CampaignHeader = _interopRequireDefault(require("../../../common/components/CampaignHeader"));

require("../styles/_manage-campaign.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ManageCampaign = /*#__PURE__*/function (_Component) {
  _inherits(ManageCampaign, _Component);

  function ManageCampaign(props) {
    var _this;

    _classCallCheck(this, ManageCampaign);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ManageCampaign).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onListFiltersChange", (0, _lodash.default)(function (_ref) {
      var createdBy = _ref.filters.createdBy,
          searchTerm = _ref.searchTerm;

      _this.fetchCampaignPosts({
        createdBy: createdBy,
        searchTerm: searchTerm
      });
    }, 300));

    _defineProperty(_assertThisInitialized(_this), "fetchApis", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Promise.all([_this.fetchCampaign(), _this.fetchCampaignPosts()]);

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "fetchCampaign", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _this$props, getInspirationCampaign, apiClient, _ref4, data, error, withCoverImage;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$props = _this.props, getInspirationCampaign = _this$props.getInspirationCampaign, apiClient = _this$props.apiClient;
              _context2.next = 3;
              return getInspirationCampaign();

            case 3:
              _ref4 = _context2.sent;
              data = _ref4.data;
              error = _ref4.error;

              if (!(!data || error || !data.getCampaign)) {
                _context2.next = 8;
                break;
              }

              return _context2.abrupt("return", void _this.setState({
                error: true
              }));

            case 8:
              _context2.prev = 8;

              if (!data.getCampaign.coverImageKey) {
                _context2.next = 15;
                break;
              }

              _context2.next = 12;
              return (0, _clientAwsS.replaceBucketKeysWithUrls)({
                apiClient: apiClient,
                data: data.getCampaign,
                substitutedKeys: ['coverImageKey']
              });

            case 12:
              _context2.t0 = _context2.sent;
              _context2.next = 16;
              break;

            case 15:
              _context2.t0 = data.getCampaign;

            case 16:
              withCoverImage = _context2.t0;

              _this.setState({
                campaign: withCoverImage
              });

              _context2.next = 23;
              break;

            case 20:
              _context2.prev = 20;
              _context2.t1 = _context2["catch"](8);

              _this.setState({
                campaign: _objectSpread({}, data.getCampaign, {
                  coverImageKey: void 0
                })
              });

            case 23:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[8, 20]]);
    })));

    _defineProperty(_assertThisInitialized(_this), "fetchCampaignPosts", /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _ref6,
            _ref6$createdBy,
            createdBy,
            searchTerm,
            getInspirationCampaignPosts,
            _ref7,
            data,
            error,
            _args3 = arguments;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _ref6 = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {}, _ref6$createdBy = _ref6.createdBy, createdBy = _ref6$createdBy === void 0 ? 'createdByEveryone' : _ref6$createdBy, searchTerm = _ref6.searchTerm;
                getInspirationCampaignPosts = _this.props.getInspirationCampaignPosts;
                _context3.next = 4;
                return getInspirationCampaignPosts({
                  createdBy: createdBy,
                  searchTerm: searchTerm
                });

              case 4:
                _ref7 = _context3.sent;
                data = _ref7.data;
                error = _ref7.error;

                if (!(!data || error || !data.getInspirationPostsForCampaign)) {
                  _context3.next = 9;
                  break;
                }

                return _context3.abrupt("return", void _this.setState({
                  error: true
                }));

              case 9:
                _this.setState({
                  posts: data.getInspirationPostsForCampaign
                });

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function () {
        return _ref5.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "handleCampaignUpdate", function (campaign) {
      _this.setState({
        campaign: campaign
      }, _this.fetchCampaign);
    });

    _defineProperty(_assertThisInitialized(_this), "toggleAddPosts", function () {
      _this.setState(function (_ref8) {
        var addingPosts = _ref8.addingPosts;
        return {
          addingPosts: !addingPosts
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleActive", /*#__PURE__*/function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(isActive) {
        var updateCampaign, _this$state$campaign, originalActive, _ref11, data, error;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                updateCampaign = _this.props.updateCampaign;
                _this$state$campaign = _this.state.campaign;
                _this$state$campaign = _this$state$campaign === void 0 ? {} : _this$state$campaign;
                originalActive = _this$state$campaign.isActive;

                _this.setState(function (_ref10) {
                  var campaign = _ref10.campaign;
                  return {
                    campaign: _objectSpread({}, campaign, {
                      isActive: isActive
                    })
                  };
                });

                _context4.next = 7;
                return updateCampaign({
                  input: {
                    isActive: isActive
                  }
                });

              case 7:
                _ref11 = _context4.sent;
                data = _ref11.data;
                error = _ref11.error;

                if (!(data && !error && data.updateCampaign)) {
                  _context4.next = 12;
                  break;
                }

                return _context4.abrupt("return");

              case 12:
                _this.setState(function (_ref12) {
                  var campaign = _ref12.campaign;
                  return {
                    campaign: _objectSpread({}, campaign, {
                      isActive: originalActive
                    })
                  };
                });

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x) {
        return _ref9.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "onRemovePost", function (inspirationId) {
      return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _this$props2, campaignId, updateInspiration, _ref14, data, error;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this$props2 = _this.props, campaignId = _this$props2.campaignId, updateInspiration = _this$props2.updateInspiration;
                _context5.next = 3;
                return updateInspiration({
                  inspirationId: inspirationId,
                  input: {
                    removeCampaignIds: [campaignId]
                  }
                });

              case 3:
                _ref14 = _context5.sent;
                data = _ref14.data;
                error = _ref14.error;

                if (!(!data || !data.updateInspiration || error)) {
                  _context5.next = 8;
                  break;
                }

                return _context5.abrupt("return");

              case 8:
                _this.setState(function (_ref15) {
                  var posts = _ref15.posts;
                  var postIndex = posts.findIndex(function (_ref16) {
                    var singleInspirationId = _ref16.inspirationId;
                    return singleInspirationId === inspirationId;
                  });

                  var newPosts = _toConsumableArray(posts);

                  newPosts.splice(postIndex, 1);
                  return {
                    posts: newPosts
                  };
                });

              case 9:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "toggleManage", function () {
      _this.setState(function (_ref17) {
        var managingCampaign = _ref17.managingCampaign;
        return {
          managingCampaign: !managingCampaign
        };
      });
    });

    _this.state = {
      error: false,
      campaign: {},
      posts: []
    };
    return _this;
  }

  _createClass(ManageCampaign, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fetchApis();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          history = _this$props3.history,
          apiClient = _this$props3.apiClient,
          updateCampaign = _this$props3.updateCampaign,
          campaignId = _this$props3.campaignId;
      var _this$state = this.state,
          campaign = _this$state.campaign,
          posts = _this$state.posts,
          addingPosts = _this$state.addingPosts,
          error = _this$state.error,
          managingCampaign = _this$state.managingCampaign;
      var coverImageKey = campaign && campaign.coverImageKey ? campaign.coverImageKey : undefined;

      if (error) {
        return _react.default.createElement(_commonReact.Error, null);
      } // const startDate = campaign && campaign.startDate
      //   ? moment(campaign.startDate, 'x').format('Do MMM YYYY')
      //   : '';
      // const endDate = campaign && campaign.endDate
      //   ? moment(campaign.endDate, 'x').format('Do MMM YYYY')
      //   : '';


      var hasUpdatePermission = (0, _commonReact.hasPermission)('UPDATE', campaign.permissions);
      return _react.default.createElement("div", {
        className: "manage-campaign page"
      }, hasUpdatePermission ? _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_AddPostsModal.default, {
        visible: addingPosts,
        hideModal: this.toggleAddPosts,
        campaignId: campaignId,
        onAddPosts: this.fetchCampaignPosts
      }), _react.default.createElement(_UpdateCampaignModal.default, {
        visible: managingCampaign,
        campaign: campaign,
        hideModal: this.toggleManage,
        updateCampaign: updateCampaign,
        onCampaignUpdated: this.handleCampaignUpdate,
        apiClient: apiClient,
        createCampaign: Function.prototype
      })) : null, _react.default.createElement(_CampaignHeader.default, {
        coverImageKey: coverImageKey
      }, _react.default.createElement(_uiKit.PageHeader, {
        title: campaign && campaign.name,
        subtitle: "Inspiration",
        actionBtnText: hasUpdatePermission ? 'Modify Campaign' : void 0,
        actionBtnOnClick: hasUpdatePermission ? this.toggleManage : void 0,
        breadCrumbs: [{
          title: 'Inspiration',
          url: '/inspiration'
        }, {
          title: 'Manage Posts',
          url: '/inspiration/manage'
        }, {
          title: 'Campaigns',
          url: '/inspiration/manage/campaigns'
        }],
        history: history
      })), _react.default.createElement("div", {
        className: "manage-campaign__content column"
      }, _react.default.createElement("div", {
        className: "manage-campaign__content__overview"
      }, _react.default.createElement("div", {
        className: "manage-campaign__content__overview__description"
      }, _react.default.createElement(_uiKit.Text, {
        heading3: true,
        prefixIcon: "brief"
      }, "Description"), _react.default.createElement(_uiKit.Text, {
        className: (0, _classnames.default)('manage-campaign__content__overview__description__text'),
        placeholder: !campaign || !campaign.description,
        ellipsisOverflow: true
      }, campaign && (campaign.description || "No description has been added to ".concat(campaign.name))), _react.default.createElement(_Tags.default, {
        large: true,
        tags: campaign && campaign.tags
      })), _react.default.createElement(_uiKit.ElevatedContainer, {
        rounded: true,
        className: "manage-campaign__content__overview__status"
      }, _react.default.createElement(_uiKit.Text, null, "This campaign is currently:"), _react.default.createElement("div", {
        className: "manage-campaign__content__overview__status__toggle"
      }, _react.default.createElement(_uiKit.Text, null, campaign && campaign.isActive ? 'Active' : 'Inactive'), _react.default.createElement(_uiKit.Switch, {
        checked: Boolean(campaign && campaign.isActive),
        onChange: this.toggleActive,
        disabled: !hasUpdatePermission
      })))), _react.default.createElement(_uiKit.Text, {
        heading3: true,
        prefixIcon: "guide"
      }, "Campaign Posts"), _react.default.createElement(_uiKit.List, {
        onFiltersChange: this.onListFiltersChange,
        listKey: "inspirationId",
        history: history,
        data: posts,
        loading: !campaign,
        renderListItem: (0, _PostListItem.default)({
          onRemovePost: this.onRemovePost,
          hasUpdatePermission: hasUpdatePermission
        }),
        hideInspiration: true,
        filtersRightAddon: hasUpdatePermission ? _react.default.createElement(_uiKit.Button, {
          className: "manage-campaign__content__add-posts-btn",
          onClick: this.toggleAddPosts
        }, "Add Posts") : null,
        filters: {
          createdBy: [{
            label: 'Created by everyone',
            value: 'createdByEveryone'
          }, {
            label: 'Created by me',
            value: 'createdByMe'
          }]
        }
      })));
    }
  }]);

  return ManageCampaign;
}(_react.Component);

exports.default = ManageCampaign;